import { useState } from 'react';

const STEPS = [
  { title: 'Create Your First Deal', description: 'Go to Deals > Create Deal to set up your first flash sale. Set the item, price, discount tiers, and number of slots.' },
  { title: 'Track Performance', description: 'Visit the Analytics page to see how your deals perform. Track claims, conversion rates, and revenue.' },
  { title: 'Set Up Scanner', description: 'Go to Scanner Setup to generate a PIN. Your cashier will use this PIN to log into the scanner app and validate customer QR codes.' },
];

export function OnboardingTour({ onComplete }: { onComplete: () => void }) {
  const [step, setStep] = useState(0);
  const current = STEPS[step];

  const handleNext = () => {
    if (step < STEPS.length - 1) setStep(step + 1);
    else handleComplete();
  };

  const handleComplete = () => {
    localStorage.setItem('merchant_onboarding_completed', 'true');
    onComplete();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="mx-4 max-w-md rounded-2xl bg-white p-8 shadow-xl">
        <div className="mb-2 text-sm text-gray-500">Step {step + 1} of {STEPS.length}</div>
        <h2 className="mb-3 text-2xl font-bold">{current.title}</h2>
        <p className="mb-6 text-gray-600">{current.description}</p>
        <div className="flex justify-between">
          <button onClick={handleComplete} className="text-sm text-gray-500 hover:text-gray-700">Skip</button>
          <button onClick={handleNext} className="rounded-lg bg-primary px-6 py-2 font-medium text-white hover:bg-primary/90">
            {step < STEPS.length - 1 ? 'Next' : 'Get Started'}
          </button>
        </div>
        {/* Step dots */}
        <div className="mt-4 flex justify-center gap-2">
          {STEPS.map((_, i) => (
            <div key={i} className={`h-2 w-2 rounded-full ${i === step ? 'bg-primary' : 'bg-gray-300'}`} />
          ))}
        </div>
      </div>
    </div>
  );
}
